import Immutable from 'immutable'
import moment from 'moment'

export const RestrictionRecord = Immutable.Record({
  approved: null,
  approvedBy: null,
  clientServiceId: null,
  dateApplied: null,
  dateNotified: null,
  delayReason: null,
  delayUntil: null,
  expires: null,
  handler: null,
  id: null,
  invoice: null, // Overdue suspension
  period: null, // Overlimit restriction
  type: null,
}, 'ServiceRestriction')

export default function createServiceRestriction({
  approved,
  client_service_id,
  date_applied,
  date_notified,
  delay_until,
  expires,
  invoice,
  ...data
}) {
  /* eslint-disable camelcase */
  return new RestrictionRecord({
    approved: approved ? moment(approved) : null,
    clientServiceId: parseInt(client_service_id, 10),
    dateApplied: date_applied ? moment(date_applied) : null,
    dateNotified: date_notified ? moment(date_notified) : null,
    delayUntil: delay_until ? moment(delay_until) : null,
    expires: expires ? moment(expires) : null,
    invoice: invoice ? invoice.id : null,
    ...data,
  })
  /* eslint-enable camelcase */
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Restriction.js